import { sendDataEvent } from "//gunner.com/cdn/shop/t/611/assets/data-capture_send-event.js?v=89369398181597458251717752096";

const shippingMapPopup = document.querySelector('.shipping-map-popup');


// showShippingMapPopup()
const showShippingMapPopup = () => {

  const eventData = {
    event_name: 'modal_viewed',
    event_element_id: 'ah56pF5dQxqIYrdNmC0nsr5H8ULMqaCM'
  };
  sendDataEvent(eventData);
  
  // Show the shipping map popup.
  shippingMapPopup.style.zIndex = '9999999999';
  shippingMapPopup.classList.add('visible');

  // Show the popup underlay.
  showPopupUnderlay('shipping-map-popup');
};


// hideShippingMapPopup()
const hideShippingMapPopup = () => {

  // Hide the shipping map popup.
  shippingMapPopup.classList.remove('visible');
  setTimeout(() => shippingMapPopup.style.zIndex = null, 150);

  // Hide the popup underlay.
  hidePopupUnderlay('shipping-map-popup');
};


// Shipping map popup buttons click event listener.
document.querySelectorAll('.shipping-map-button').forEach(shippingMapButton => {
  shippingMapButton.addEventListener('click', () => showShippingMapPopup())
  // shippingMapButton.addEventListener('touchstart', (e) => {
  //   e.preventDefault();
  //   showShippingMapPopup();
  // });
});

// Shipping map popup click outside handling.
// If the shipping map popup is currently visible && the target is not the shipping map button && (the click is not within the popup || is the popup close button) - hide the shipping map popup.
document.addEventListener('click', (e) => {
  if (shippingMapPopup.classList.contains('visible') && !e.target.classList.contains('shipping-map-button')  && (!shippingMapPopup.querySelector('.shipping-map-popup-inner').contains(e.target) || e.target === shippingMapPopup.querySelector('.shipping-map-popup-close'))) {
    hideShippingMapPopup();

    const eventData = {
      event_name: 'click_outside_close',
      
event_element_id: 'ah56pF5dQxqIYrdNmC0nsr5H8ULMqaCM'
    };
    sendDataEvent(eventData);
    
  }
});